import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=5ef88b2c&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=5ef88b2c&prod&lang=scss"
import style1 from "./Base.vue?vue&type=style&index=1&id=5ef88b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef88b2c",
  null
  
)

export default component.exports